<!--
 * @Description: 用户下拉全局
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-05-16 17:03:53
 * @LastEditors: cxh
-->
<template>
  <a-select
    v-bind="$attrs"
    v-model:value="data"
    :mode="mode"
    style="width: 100%"
    ref="userselect"
    @change="change"
    allowClear
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="fetchUser"
    placeholder="请选择"
  >
    <a-select-option v-for="item in optionPageComputed" :key="item.employeeNo" :value="item.employeeNo">{{
      `${item.userName}(${item.employeeNo})`
    }}</a-select-option>
  </a-select>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from 'vue'
import { listByUsers, fetchUsersByWorkCode } from '@/api/common'
import { debounce, differenceBy, uniqBy } from 'lodash-es'
import { useRequest } from 'vue-request'
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  label: {
    type: [String, Number]
  },
  mode: {
    type: String
  }
})
const data = ref()
const userselect = ref()
const emit = defineEmits(['update:value', 'update:label', 'change'])
const optionPage = ref<any[]>([])
const pageNumber = ref(1)
const searchTxt = ref('')
const valueList = ref<any[]>([])
const change = (value: any) => {
  const record = optionPageComputed.value.find((item: any) => item.employeeNo === value)
  emit('update:value', value)
  emit('update:label', record?.userName)
  emit('change', record)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const optionPageComputed = computed(() => {
  if (searchTxt.value) {
    return optionPage.value
  }
  return uniqBy([...valueList.value, ...optionPage.value], 'employeeNo')
})
// 是否请求接口
const needFetchValue = (v: any[]) => {
  if (v && v.length) {
    const vL = v.map((v) => {
      return {
        employeeNo: v
      }
    })
    const valueArr = differenceBy(vL, optionPage.value, 'employeeNo')
    if (valueArr) {
      if (searchTxt.value) {
        fetchUser('')
      }
      // 判断是否有label
      if (v.length === 1) {
        if (v[0] === props.value && props.label) {
          valueList.value = [{ userName: props.label, employeeNo: props.value }]
          return
        }
      }
      const employeeList = valueArr.map((item: any) => item.employeeNo)
      fetchUsersByWorkCode({
        employeeList
      }).then((res) => {
        valueList.value = res.data || []
      })
    }
  }
}
onMounted(() => {
  initFetch()
})
const fetchUser = debounce((txt: string) => {
  // 去掉前后空格
  searchTxt.value = txt.trim()
  optionPage.value = []
  pageNumber.value = 1
  fetch()
}, 500)
const initFetch = () => {
  const p = {
    pageNumber: 1,
    pageSize: 100,
    dataRangeQueryFlag: false
  }
  useRequest(listByUsers, {
    defaultParams: [p],
    cacheKey: JSON.stringify(p),
    onSuccess: (res) => {
      optionPage.value = [...optionPage.value, ...res.data.items]
    }
  })
}
const fetch = () => {
  listByUsers({
    pageNumber: pageNumber.value,
    pageSize: 100,
    dataRangeQueryFlag: false,
    keyword: searchTxt.value
  }).then((res) => {
    if (pageNumber.value === 1) {
      optionPage.value = []
    }
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
watch(
  () => props.value,
  (v) => {
    if (!v) {
      data.value = v
      // 处理搜索
      if (searchTxt.value) {
        fetchUser('')
      }
    } else if (typeof v === 'string' && v !== data.value) {
      data.value = v
      needFetchValue([v])
    }
  },
  { immediate: true }
)
</script>
<script lang="ts">
export default { name: 'BatchUserList' }
</script>
